import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { usePresenceTracking } from "@/hooks/usePresence";
import { User } from "@supabase/supabase-js";

/**
 * Component that tracks user presence globally when logged in.
 * Should be placed at the root level (App.tsx) to ensure presence is tracked
 * across all routes, not just /app.
 */
export const PresenceTracker = () => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    // Set up auth state listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      setUser(session?.user ?? null);
    });

    // Check for existing session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Track presence for logged-in users
  usePresenceTracking(user?.id, user?.email ?? undefined);

  return null; // This component doesn't render anything
};
